import React from "react";
import Logo from "../assests/images/logo.png";
import { Container, Button, Row, Col } from "react-bootstrap";
import Particles from "../Utils/Particles";
import Typewriter from "typewriter-effect";

export default function Home() {
  return (
    <>
      <Container className="h-100 home-container" role="main">
        <Row className="h-100 justify-content-md-center">
          <Col className="my-auto" xs={6}>
            <h3 className="color-custom-grey font-weight-bold mb-0">
              Hey ! , <span className="color-name-blue text-boldest">I'm</span>
            </h3>
            <h1 className="text-boldest" style={{ color: "red" }}>
              <Typewriter
                options={{
                  strings: ["Kalyan Raju Namburi", "Kalyan Raju...!"],
                  autoStart: true,
                  loop: true,
                  pauseFor: 1500,
                  delay: 50,
                  deleteSpeed: 75,
                }}
              />
            </h1>

            <h4 className="color-custom-grey ">
              <span>I'm a </span>
              <span className="font-weight-bold">
                <span className="font-weight-bold">
                  Full Stack
                  <span className="font-weight-normal"> Developer</span>
                </span>
              </span>
            </h4>
            <div className="d-flex my-4 ">
              <Button
                variant=""
                className="color-custom-blue p-0 mr-3 border-0"
                aria-label="github"
                onClick={() =>
                  window.open("https://www.guvi.in/kalyanraju53100", "_blank")
                }
              >
                <img
                  src={Logo}
                  alt="hackerrank"
                  style={{
                    fontSize: "2rem",
                    width: "40px",
                    height: "40px",
                    marginRight: "20px",
                    outline: "none",
                  }}
                />
              </Button>
              <Button
                variant=""
                className="color-custom-blue p-0 mr-3 border-0"
                aria-label="hackerrank"
                onClick={() =>
                  window.open("https://github.com/kalyan-maker", "_blank")
                }
              >
                <i
                  class="devicon-github-original-wordmark colored"
                  style={{ fontSize: "2rem", outline: "none" }}
                />
              </Button>
            </div>
            <div className="d-flex my-4 ">
              <Button
                className="bg-custom-blue font-weight-bold shadow-sm border-0 resume-btn "
                onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/1Cmr83gBPbs7dkvUD8lEHxUDNki6EgtTn/view?usp=sharing",
                    "_blank"
                  )
                }
              >
                View Resume
              </Button>
            </div>
          </Col>
          {/* <Col
            className="w-30 h-45 mt-20 my-auto d-none d-md-block"
            style={{ float: "end" }}
          >
            <DeveloperSvg />
          </Col> */}
        </Row>
      </Container>
      <Particles />
    </>
  );
}
